var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComingSoon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 228,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m179.4 143.6-5.5-29.2-42.9 29.8 2 42 46.4-42.6ZM115.1 51.2l24 13.2-42.9 29.9-36.7-13.6 55.6-29.5Z",
    fill: "#FB5A21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m95.5 132.5 9.2-6.3 9.1-6.4 97.6-68s-16-10-51.5.4a246 246 0 0 0-87.4 47.3L77 106l-6.1 4.2 5.4 7.8-6.1 4.2 13 18.7 6.1-4.2 6.1-4.3Z",
    fill: "#DCDFD9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m95.5 132.5 9.2-6.3 9.1-6.4 97.6-68s4.2 18.9-17.7 48.9a240.2 240.2 0 0 1-74.5 65.9l-4.7-6.8-6.1 4.2-5.6-8-6 4.3L83.2 141l6.1-4.2 6.1-4.3Z",
    fill: "#F9F1F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m68.7 140 11.8 17c6.5 9.3-25.3 21-26.9 18.7-1.6-2.3-16.7-.9-16.7-.9s7.3-12.5 5-16c-2.5-3.5 20.8-27.4 26.8-18.7Z",
    fill: "#E36018"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m69.7 141.6 9.8 14c5.3 7.7-18.9 15.9-20.2 14-1.3-2-13-1.4-13-1.4s5.3-9.7 3.3-12.6c-2-2.9 15.1-21.2 20.1-14Z",
    fill: "#FFAE44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m71.2 143.8 6.7 9.5c3.7 5.3-12.5 10.7-13.4 9.4-1-1.3-8.8-1-8.8-1s3.5-6.6 2.1-8.6c-1.3-2 10-14.2 13.4-9.3Z",
    fill: "#FCE25E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m72.8 126 21.7 31-12.6 6-18.4-26.3 9.3-10.7Z",
    fill: "#5B6575"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 179.6,
    cy: 74.3,
    r: 13.4,
    transform: "rotate(55.1 179.6 74.3)",
    fill: "#00D5CC",
    stroke: "#5B6575",
    strokeWidth: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m141 90.8 14.7-.5-5.5 13.7-68.9 38.2 59.8-51.4Z",
    fill: "#FB5A21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoon);
export default __webpack_public_path__ + "static/media/comingSoon.d1cb00ca38226a3de341e4703d325b0f.svg";
export { ForwardRef as ReactComponent };